module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/array-buffer-native.js
// module id = 234
// module chunks = 0